/* eslint-disable import/no-duplicates */
/* eslint-disable camelcase */
import { ExtraSchema, Requisite, SelectorValue } from 'shared/models/Payments'

import {
  DepositResponseType,
  FieldTypesType,
  PaymentListStatusesType,
  PaymentMethodsType,
  PaymentSystemNamesType,
  PaymentValidationType,
} from './common'

export interface IServerResponse<DataType> {
  success: boolean
  data: DataType
  errorMessage: any
  codeStatus: any
}

export type transactionStatusesType = 'OPEN' | 'IN_PROCESS' | 'COMPLETED' | 'REJECTED'

export type transactionType = 'withdrawal' | 'deposit'

export type transactionTypeWithAll = 'all' | transactionType

export type transactionStatusWithAll = transactionStatusesType | 'All'

export enum TransactionItemType {
  DEPOSIT = 'deposit',
  WITHDRAW = 'withdraw',
}

export interface IDefaultServerResponse<DataType> {
  success: boolean
  data: IDefaultDataResponse<DataType>
  errorMessage: any
  codeStatus: any
}

export interface IDefaultDataResponse<DataType> {
  count: number
  page: number
  page_size: number
  has_next: boolean
  has_previous: boolean
  results: DataType[] | []
}

export interface IDefaultDataResponseByService<DataType> {
  total_items: number
  total_pages: number
  page: number
  page_size: number
  has_next: boolean
  has_previous: boolean
  items: DataType[] | []
}

export interface IDefaultDataConverted<DataType> {
  count: number
  page: number
  list: DataType[] | []
}

export interface IDefaultFilters {
  page: number
  page_size?: number
}

export interface ICreateDepositPayload {
  system: string
  amount: number
  id: string
  extra: {
    [key: string]: string | number
  }
}

export interface ICreatePayoutPayload {
  system: string
  amount: number
  number?: number
  crypto_currency?: string
  crypto_wallet_address?: string
}

// approve_list
export interface IApproveListItemDTO {
  id?: number
  redirect_link?: string
  amount_currency?: string
  amount?: string
  status?: PaymentListStatusesType
  created_at?: string
  updated_at?: string
  user: number
  payment_system?: any
  payout_system?: number
}

export interface IApproveListItem {
  paymentId?: number
  redirectLink?: string
  amountCurrency?: string
  amount?: string
  status?: PaymentListStatusesType
  createdAt?: string
  updatedAt?: string
  user: number
  paymentSystem: number
}

// callback
export interface ICallbackPayload {
  var: string
  slug: string
}

// manual_list
export interface IManualListItemDTO {
  id?: number
  redirect_link?: string
  amount_currency?: string
  amount?: string
  status?: PaymentListStatusesType
  created_at?: string
  updated_at?: string
  user: number
  payment_system?: any
  payout_system?: number
}

export interface IManualListItem {
  id?: number
  redirectLink?: string
  amountCurrency?: string
  amount?: string
  status?: PaymentListStatusesType
  createdAt?: string
  updatedAt?: string
  user: number
  paymentSystem: number
}

// system_list

export interface ISystemListItem {
  name: PaymentSystemNamesType
  method: PaymentMethodsType
  min: number
  max: number
  slug: string
  isDisabled: Boolean
  currency: string
  depositImagesEnabled: boolean
  depositImagesRequired: boolean
  depositImagesMaxCount: number
  fields: ExtraSchema[] | []
  requisites: Requisite[]
  description?: string
}
//
interface IActionStatusData {
  redirect_link?: string
  amount?: string
  status?: PaymentListStatusesType
  user: number
  payment_system: number
}

export interface IActionStatusPayload {
  id: number
  data: IActionStatusData
}

export interface ICryptoCurrencyListDTO {
  selectedCurrencies: string[]
}

export interface ICryptoCurrencyWithMinAndMaxItem {
  currency: string
}

export interface ICreateCryptoPaymentDTO {
  payment_id: string
  pay_address: string
  pay_currency: string
}

export interface ICryptoMinAmountDTO {
  currency_from: string
  min_amount: number
  fiat_equivalent: number
}

export interface ICryptoMinAmount {
  currency: string
  min: number
  fiatAmount: number
}

export interface ICreateCryptoPaymentData {
  id: string
  address: string
  currency: string
}

export enum OnlinePaymentTypes {
  DEPOSIT = 'deposit',
  PAYOUT = 'payout',
}

export enum OnlinePaymentStatuses {
  EXPRIRED = 'Expired',
  STARTED = 'Started',
  WAITING = 'Waiting',
  SUCCESS = 'Success',
}

export interface IHistoryPaymentDTO {
  id: number
  currency: string
  amount: number
  status: OnlinePaymentStatuses
  payment_system: string
  created_at: string
  payment_by: string
  payment_type: OnlinePaymentTypes
}

export interface IConvertedHistoryPaymentItem {
  id: string
  paymentId: string
  currency: string
  amount: number
  status: string
  paymentSystem: string
  createdAt: string
  paymentType: OnlinePaymentTypes
}

export interface IConvertedHistoryPayment {
  page: number
  count: number
  items: IConvertedHistoryPaymentItem[] | []
}

export interface IQRCode {
  url: string
  expirationDate: number
}

export interface ICryptoVariables {
  cryptoAmount: number
  fiatAmount: number
  fiatCurrency: string
}

export interface ISystemFieldValuesDTO {
  type: 'string' | 'number' | 'password'
  fieldType?: FieldTypesType
  field_duplicate?: string
  max_length?: number
  min_length?: number
  validation?: PaymentValidationType
  value?: string | number
  values?: SelectorValue[]
  optional?: boolean
  disabled?: boolean
  placeholder?: string
  endAdornmentType?: 'lockBlock'
}

export type ISystemFieldsDTO = {
  [key: string]: ISystemFieldValuesDTO | ISystemFieldsDTO
}

export type RequisiteFieldDTO = {
  name: string
  value: string
}
export interface ISystemListItemDTO {
  name: PaymentSystemNamesType
  method: PaymentMethodsType
  description: string
  min: number
  max: number
  is_disabled: Boolean
  currency: string
  extra_schema: ISystemFieldsDTO
  deposit_images_enabled: boolean
  deposit_images_required: boolean
  deposit_images_max_count: number
  requisites: RequisiteFieldDTO[]
}

export interface IDepositDTO {
  type: DepositResponseType
  payment_invocation: string
  external_id: number
  variables?: { [val: string]: string }
}

export interface IDeposit {
  type: DepositResponseType
  redirectLink: string | null
  qrCodeData: IQRCode | null
  externalId: number
  walletAddress: string | null
  variables: ICryptoVariables | null
}

export interface ICryptoEstimateAmountDTO {
  currency_from: string
  amount_from: number
  currency_to: string
  estimated_amount: string
}

export interface ICryptoEstimateAmount {
  currencyFrom: string
  amountFrom: number
  currencyTo: string
  estimatedAmount: string
}

export type IUploadDocumentPayload = FormData

export interface IGetCryptoEstimateAmountPayload {
  amount: number
  currencyFrom: string
  currencyTo: string
}

export interface ICashierItemDTO {
  id: number
  username: string
  email: string
  balance: string
  balance_currency: string
  language: string
}

export interface ICashierItem {
  id: number
  username: string
}

export interface IRequestCotePayout {
  amount: number
  extra: {
    cashier_id: number
  }
}

export interface UploadScreenshotDTO {
  index: number
  key?: string
  original_name: string
  status: string
  status_code: number
  error_message?: string
}
